import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { recordRouteChange } from "@/lib/loginFlowTelemetry";

/**
 * Observa mudanças de rota e alimenta a telemetria do fluxo de login.
 * Renderiza nada; existe só como ponto de instrumentação dentro do Router.
 */
const LoginFlowTelemetry = () => {
  const location = useLocation();
  useEffect(() => {
    recordRouteChange(location.pathname);
  }, [location.pathname]);
  return null;
};

export default LoginFlowTelemetry;
